<div class="app-container responsive-container">
  <cc-box>
    <div content box>
        <div class="table-search">
          <i class="material-icons">search</i>
          <input matInput
                 [formControl]="phraseControl"
                 class="search-input"
                 [placeholder]="'SEARCH' | translate" />
        </div>
        <div class="unknown-checkbox">
          <mat-checkbox
            [checked]="filters.showContactsWithEmptyName"
            (change)="toggleContactsWithEmptyNameSearch($event)">{{'SHOW_UNKNOWN' | translate}}</mat-checkbox>
        </div>
      <mat-table
        (matSortChange)="sortChange($event)"
        matSort
        [dataSource]="dataSource"
        class="table"
      >
        <ng-container matColumnDef="contactName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'ADDRESS_BOOK.CONTACT_NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="name"
                 *ngIf="element.contactName"
                 [title]="element.contactName"
            >{{element.contactName}}</div>
            <div class="name" *ngIf="!element.contactName">{{'UNKNOWN' | translate}}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="contactSurname">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'ADDRESS_BOOK.CONTACT_SURNAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="surname"
                 *ngIf="element.contactSurname"
                 [title]="element.contactSurname"
            >{{element.contactSurname}}</div>
            <div class="surname" *ngIf="!element.contactSurname">{{'UNKNOWN' | translate}}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="msisdn">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'ADDRESS_BOOK.PHONE_NUMBER' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="msisdn-wrapper">
              <div class="msisdn">
              <span
                class="flag-icon flag-icon-{{getNumbersCountry(element.msisdn).toLowerCase()}} m-r-sm shadow-up"></span>
                <span>{{ element.msisdns[0] }}</span>
              </div>
              <div class="tooltip-wrapper">
                <div *ngIf="element.msisdns.length > 1">
                  <span matTooltip="{{formatNumbers(element.msisdns)}}" matTooltipPosition="right"
                        matTooltipClass="msisdn-tooltip" class="tooltip-number">+{{ element.msisdns.length - 1 }}
                  </span>
                </div>
              </div>
            </div>
            <cc-call-icon
              *ngIf="getNumbersCountry(element.msisdns[0])"
              [number]="element.msisdns[0]"
            ></cc-call-icon>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="contactEmail">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'ADDRESS_BOOK.CONTACT_EMAIL' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="email">
              <div *ngIf="element.contactEmail " class="details-email">{{ element.contactEmail }}</div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'ADDRESS_BOOK.COMPANY' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="company-wrapper">
            <div class="company">
              <div *ngIf="element.companyName " class="details-email">{{ element.companyName }}</div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="contactDetails" sticky>
          <mat-header-cell *matHeaderCellDef class="details-info-header">
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="details-info-wrapper">
          <span (click)="contactDetailsClicked()"
                [routerLink]="['/contact-details/' + element.id + '/0']"
                class="material-icons info">info</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [length]="paginator.length"
        [pageSize]="paginator.pageSize"
        (page)="changePage($event)"
      ></mat-paginator>

    </div>
  </cc-box>
</div>
